import "./index.css";
import BottomBar from "../../components/bottomBar";
import TopBar from "../../components/topBar";
import Chart from "./components/chart";
import pako from "pako";
import { useState } from "react";
import { useEffect } from "react";
import { Toast } from "antd-mobile";
import { useTranslation } from "react-i18next";
import { getText } from "../../utils/util";
import { userApi } from "../../api/user-api";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";
import Center from "./components/center/index";

export default function SecurityCenter() {
  const uid = localStorage.getItem("uid");
  const [userInfo, setUserInfo] = useState({});
  const [type, setType] = useState(true);
  const { t: translate } = useTranslation();

  const loadUserInfoData = async () => {
    const data = await userApi.userInfo();
    if (data.ok) {
      setUserInfo(data.data);
    }
  };

  useEffect(() => {
    loadUserInfoData();
  }, []);
  
  return (
    <div className="min-h-screen bg-neutral-900 w-full revert-style">
      <AcendexLayout
        theme="light"
        mobileTopBarTitle={translate(getText("安全中心"))}
        pcTopBarTitle={translate(getText("安全中心"))}
        hideBottomBar
      >
        <div className="container mx-auto px-4 py-6 space-y-4">
          <div className="bg-neutral-800 rounded-xl p-6 mb-4">
            <Chart userInfo={userInfo} />
          </div>
          <div className="bg-neutral-800 rounded-xl p-4">
            <Center userInfo={userInfo} />
          </div>
        </div>
      </AcendexLayout>
    </div>
  );
}
